import GlobalContextDefinition from "./GlobalContextDefinition";

const initial: GlobalContextDefinition = {
	skipPayment: false,
	idUsuario: undefined,
	nome: undefined,
	dataNascimento: "",
	cpf: "",
	celular: "",
	sexoBiologico: undefined,
	app: undefined,
	token: undefined,
};

export default initial;
